import { schema } from 'normalizr';
import channel from './channel';

const courseSchema = new schema.Entity('courses', {
  channel,
  managers: [new schema.Entity('members')],
});

export default courseSchema;
